import Pricing3 from './Pricing3'
export default Pricing3
